<template>
  <div class="scrollable-content flex-grow-1" :style="outerStyles">
    <div class="header">
      <slot name="header"></slot>
    </div>
    <div class="body">
      <slot></slot>
    </div>

    <div class="footer">
      <slot name="footer"></slot>
    </div>
    
  </div>
</template>

<script>

export default {
  name: 'ScrollableContent',
  props : {
    'float' : {type:Boolean, default:false},
    
  },
  components: {},
  mounted(){
    this.hasMounted = true;
  },
  computed : {
    outerStyles()
    {
      var floatStyles = {};
      if(this.hasMounted && this.float && this.$el)
      {
      }

      var result = {

      };
      return Object.assign(result,floatStyles);
    },
  },
  data()
  {
    return {
      hasMounted : false,
    }
  },
  methods : {
  }
}
</script>

<style scoped lang="scss">
.scrollable-content
{
  width:100%;
  height:100%;

  display:flex;
  flex-direction:column;
  // background-color:magenta;

  >.header
  {
    flex-basis:auto;
  }
  >.body
  {
    flex-grow:1;
    overflow-y:auto;
    display:flex;
    flex-direction: column;
    // background-color:yellow;
  }
  >.footer
  {
    flex-basis:auto;
  }
}
</style>
